/* eslint import/no-webpack-loader-syntax: off */
require('expose-loader?BVHOCs!../src/globals/hocs');
require('expose-loader?BVComponents!../src/globals/components');
require('expose-loader?BVHooks!../src/globals/hooks');
require('expose-loader?BVContexts!../src/globals/contexts');
require('expose-loader?BVMetas!../src/globals/metas');
